import { GenericObject } from 'app/constants/GlobalTypes'
import { isNil, omitBy } from 'lodash'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function useFilterParams<T>() {
  const [searchParams, setSearchParams] = useSearchParams()

  const set = (params: GenericObject<string> | unknown) => {
    setSearchParams(omitBy(params, isNil))
  }

  const params = useMemo(() => {
    const searchObject = Object.fromEntries(new URLSearchParams(searchParams))

    Object.keys(searchObject).forEach((key) => {
      if (searchObject[key] === 'true') {
        //@ts-ignore
        searchObject[key] = true
      } else if (searchObject[key] === 'false') {
        //@ts-ignore
        searchObject[key] = false
      } else if (searchObject[key] && !isNaN(Number(searchObject[key]))) {
        //@ts-ignore
        searchObject[key] = Number(searchObject[key])
      }
    })

    return searchObject
  }, [searchParams])

  return { params: params as T, searchParams, setSearchParams: set }
}
